<template>
    <div>
        <form @submit.prevent="submit">
            <div class="form-row mb-3 align-items-center">
                <div class="form-group col-lg-4">
                    <label for="sector">{{ $t('omsz-form.labels.emission_sector') }} <span class="text-danger">*</span></label>
                    <multiselect id="sector"
                                 v-model="sector"
                                 track-by="value"
                                 label="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                 :selectedLabel="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="sectors"
                                 :allow-empty="false"
                                 :searchable="true"
                                 :class="{'is-invalid': !isValid.sector}"
                                 @select="selectSector">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                        <span slot="noResult">{{$t('omsz-form.errors.not_found')}}</span>
                    </multiselect>
                </div>
                <div class="form-group col-lg-4">
                    <label for="component">{{ $t('omsz-form.labels.pollutants') }} <span class="text-danger">*</span></label>
                    <multiselect id="component"
                                 v-model="component"
                                 track-by= "value"
                                 label="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :select-label="$t('omsz-form.placeholders.select_enter')"
                                 :selected-label="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="sector.components || []"
                                 :allow-empty="false"
                                 :searchable="false"
                                 :disabled="false"
                                 :class="{'is-invalid': !isValid.component}"
                                 @select="selectComponent">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                        <span slot="noResult">{{$t('omsz-form.errors.not_found')}}</span>
                        <span slot="noOptions">{{$t('omsz-form.placeholders.list_is_empty')}}</span>
                    </multiselect>
                </div>
                <div class="col-lg-3 buttons mt-2">
                    <button id="send"
                            type="submit"
                            :disabled="!this.sector || !this.component || this.isLoading"
                            class="btn btn-primary"
                            :class="{'loader': isLoading}">
                        <span>{{ $t('omsz.buttons.start_query') }}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>
        <div v-if="response" class="vue-img-container mb-5">
            <img :src="response.imageUrl" :alt="`${sector} ${component}`" class="img-fluid"/>
        </div>
        <div v-if="errorMessage" class="mb-5">{{errorMessage}}</div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import axios from 'axios';

export default {
    name: 'emission-map',
    components: {
        Multiselect
    },
    props: {
        sectors: {
            type: Array,
            required: true,
        },
        defaults: {
            type: Object,
            default: {
                defaultSector: null,
                defaultComponent: null,
            },
        },
    },
    data() {
        return {
            sector: null,
            component: null,
            isValid: {
                sector: true,
                component: true
            },
            isLoading: false,
            errorMessage: null,
            response: null,
        }
    },
    created() {
        if (this.defaults.defaultSector) {
            this.sector = this.sectors.find(option => option.value === this.defaults.defaultSector.value)
            this.component = this.sector.components.find(component => component.value === this.defaults.defaultComponent.value)
            this.submit();
        }
    },
    methods: {
        selectSector(e) {
            this.isValid.sector = true;
            this.component = null;
        },
        selectComponent(e) {
            this.isValid.component = true;
        },
        async submit(e) {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            this.response = null;
            this.errorMessage = null;

            const params = {
                sector: this.sector.value,
                component: this.component.value,
            };

            try {
                const { data } = await axios.post('/api/emissions/map-image', params,{
                    headers: { 'Accept-Language': window.Met.locale },
                });
                this.response = data;
            } catch (error) {
                this.errorMessage = this.$t('omsz-form.errors.not_response');
            } finally {
                this.isLoading = false;
            }
        },
    }
}
</script>
